import PartnerUser from "./PartnerUser";

import PartnerUserCollection from "./Collection";
import PartnerUserDocument from "./Document";

export default PartnerUser;

export { PartnerUserCollection, PartnerUserDocument };
